import script from "./Recruited.page.vue?vue&type=script&setup=true&lang=js"
export * from "./Recruited.page.vue?vue&type=script&setup=true&lang=js"

import "./Recruited.page.vue?vue&type=style&index=0&id=adb98394&lang=scss"

const __exports__ = script;

export default __exports__
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QPage from 'quasar/src/components/page/QPage.js';
import QList from 'quasar/src/components/item/QList.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPageContainer,QPage,QList,QCard,QCardSection});
